
/**
 * Core types for the notification system
 */

// Type definition for scheduled notifications
export interface ScheduledNotification {
  id: string;
  message: string;
  scheduled_time: string;
  created_at: string;
  status: 'pending' | 'sent' | 'failed' | 'cancelled';
  procurement_id?: string;
  recipient_ids?: string[];
  buttons?: {text: string, action: string, data: string}[];
  error_message?: string;
  sent_count?: number;
  failed_count?: number;
}

// Storage key for scheduled notifications
export const SCHEDULED_NOTIFICATIONS_KEY = 'telegram_scheduled_notifications';
